import { type StoreActionApi } from 'react-sweet-state';

import { getRovoParams, updatePageRovoParams } from '@atlaskit/rovo-triggers/params';
import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';
import { type ChatStorePrivateState } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { StoreErrorFlagId } from '../../common/ui/hooks/use-show-store-error-flag/StoreErrorFlagId';
import { removeConversationFromStore } from './removeConversationFromStore';
import { setSelectedConversation } from './setSelectedConversation';
import type { ChatStoreContainerProps } from './types';

export const handleForbiddenConversation = ({
	conversationId,
	currentConversationId,
	dispatch,
	sendAnalyticsEvent,
	showFlag,
}: {
	conversationId: string;
	currentConversationId: string;
	dispatch: StoreActionApi<ChatStorePrivateState>['dispatch'];
	sendAnalyticsEvent: ChatStoreContainerProps['sendAnalyticsEvent'];
	showFlag?: ChatStoreContainerProps['showFlag'];
}): void => {
	const rovoParams = getRovoParams();
	const isConversationIdInRovoParams = rovoParams?.conversationId === conversationId;
	const isCurrentConversation = currentConversationId === conversationId;

	sendAnalyticsEvent({
		eventType: 'track',
		action: 'forbidden',
		actionSubject: 'rovoChatFetchConversation',
		attributes: {
			isConversationIdInRovoParams,
		},
	});

	dispatch(removeConversationFromStore({ conversationId }));
	if (isCurrentConversation) {
		dispatch(setSelectedConversation({ conversationId: EMPTY_CONVERSATION_ID }));
	}

	if (isConversationIdInRovoParams) {
		updatePageRovoParams({
			conversationId: undefined,
		});
	}

	showFlag?.(StoreErrorFlagId.CONVERSATION_FORBIDDEN);
};
